import React, {Fragment, useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'react-bootstrap'
import {LoadingComponent} from 'recupero-comunes'
import Formulario from './formulario.js'
import {serviceGetSolicitudes} from '../../../api/api-solicitar-informe-profesional.js';

const AutorizarInformeProfesional = ({ showModal, setShowModal, idSolicitudInforme, idTrxOrigen}) => {

    const [cfg_form, setCfg_form] = useState(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const [solicitud, setSolicitud] = useState([]);
   
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const {llaves} = data_encargado;

    useEffect(() => {
        if (showModal) getSolicitudes();
    }, [showModal])

    const getSolicitudes = async () => {
        console.log("getSolicitudes....")
        setLoading(true);   
        const query = Buffer.from(JSON.stringify({ idCaso: llaves && llaves['idCaso'] })).toString('base64');
        const response = await serviceGetSolicitudes(query);

        let solicitud = response.filter(m => m.idSolicitud == idSolicitudInforme)

        setSolicitud(solicitud[0]);
        setLoading(false);
    }

    return (
        <Fragment>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='xl'>
                <LoadingComponent show={loading}/>
                <Formulario 
                    showModal={showModal} 
                    setShowModal={setShowModal} 
                    solicitud={solicitud}
                    idTrxOrigen={idTrxOrigen}
                />
            </Modal>            
        </Fragment>
    )
}

export default AutorizarInformeProfesional